// extracted by mini-css-extract-plugin
module.exports = {"container":"WarBeginPopup_container__2-I8o","des":"WarBeginPopup_des__3PXqW"};